import { Action, Reducer } from 'redux';
import AuthenService from "src/Service/AuthenService";
import { AuthToken } from "src/Service/Config/AuthToken";
import { getHistory } from "src/App";
import SystemFn from 'src/Service/SystemFn';
// import { getHistory } from "src/App";

interface LoginInitial {
    sUsername: string,
    sPassword: string
}
export interface AuthenInitialState {
    currentUser: any,
    Message: string,
    loading: boolean,
    loadingInit: boolean,
    MenuArray: any,
    InputLogin: LoginInitial,
}

export const AuthenInitialState: AuthenInitialState = {
    currentUser: {},
    Message: "",
    loading: false,
    loadingInit: true,
    MenuArray: [],
    InputLogin: {} as LoginInitial,
}

const prefix = 'AUTHEN';
export const authenActions = {
    ERROR_MESSAGE_CLEARED: `${prefix}_ERROR_MESSAGE_CLEARED`,

    AUTH_INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
    AUTH_INIT_ERROR: `${prefix}_INIT_ERROR`,

    AUTH_INITMENU_SUCCESS: `${prefix}_INITMENU_SUCCESS`,
    AUTH_INITMENU_ERROR: `${prefix}_INITMENU_ERROR`,

    AUTH_START: `${prefix}_AUTH_START`,
    AUTH_SUCCESS: `${prefix}_AUTH_SUCCESS`,
    AUTH_ERROR: `${prefix}_AUTH_ERROR`,

    AUTTH_GET_PERMISSION_START: `${prefix}_GET_PERMISSION_START`,
    AUTTH_GET_PERMISSION_INIT: `${prefix}_GET_PERMISSION_INIT`,
}

export const AuthenActionCreators = {
    doClearErrorMessage: () => {
        return {
            type: authenActions.ERROR_MESSAGE_CLEARED,
        };
    },
    doGetPermission: (numberPage) => async (dispatch) => {  //Beam Add
        
        let pathUrl = window.location.pathname.split("/");
        let Path = pathUrl[pathUrl.length - 1]
        dispatch({
            type: authenActions.AUTTH_GET_PERMISSION_START,
        });

        let data = {
            sMenuID: numberPage == null ? "" : numberPage + "",
            PageUrl: Path
        }
        let PRMSMode = await SystemFn.GetMenuWithPermission(data);
        if (PRMSMode == "0") {
            // await AuthenService.SignOut();
            dispatch({
                type: authenActions.AUTH_INITMENU_ERROR,
                payload: "No Permission to Menu",
            });
            getHistory().push('/Homepage');
        }
        dispatch({
            type: authenActions.AUTTH_GET_PERMISSION_INIT,

            payload: {
                PRMSMode,
            },
        });
        
        return PRMSMode;
    },
    doGetPermission_CreateIdea: (nInnovationID, nStageID, sPageUrl, sMenuPage, sMode) => async (dispatch) => {  //Beam Add
        dispatch({
            type: authenActions.AUTTH_GET_PERMISSION_START,
        });
        let data = {
            nInnovationID: nInnovationID + "",
            nStageID: nStageID + "",
            sPageUrl: sPageUrl + "",
            sMenuPage: sMenuPage + "",
            sMode: sMode + "",
        }
        let PRMSMode_Inno = await SystemFn.GetMenuWithPermission_CreateIdea(data);
        if (PRMSMode_Inno == "0") {
            // await AuthenService.SignOut();
            dispatch({
                type: authenActions.AUTH_INITMENU_ERROR,
                payload: "No Permission To Notification Menu Create Idea.",
            });
            getHistory().push('/Homepage');
        }
        dispatch({
            type: authenActions.AUTTH_GET_PERMISSION_INIT,
            payload: {
                PRMSMode_Inno,
            },
        });        
        return PRMSMode_Inno;
    }
}

export const AuthenReducer = (state = AuthenInitialState, { type, payload }) => {
    if (state === undefined) {
        return AuthenInitialState;
    }
    switch (type) {
        case authenActions.ERROR_MESSAGE_CLEARED:
            return {
                ...state,
                loading: false,
            };
        case authenActions.AUTH_START:
            return {
                ...state,
                currentUser: {},
                MenuArray: [],
                InputLogin: payload.InputLogin || {},
                Message: "",
                loading: true
            }
        case authenActions.AUTH_SUCCESS:

            return {
                ...state,
                currentUser: payload.currentUser || {},
                InputLogin: payload.InputLogin || {},
                Message: "",
                loading: true,
                loadingInit: false,
            }
        case authenActions.AUTH_ERROR:
            return {
                ...state,
                currentUser: {},
                Message: payload.Message,
                InputLogin: payload.InputLogin || {},
                loading: false
            }
        case authenActions.AUTH_INIT_SUCCESS:

            return {
                ...state,
                Message: payload.Message,
                loadingInit: false,
                currentUser: payload.currentUser || {},
            }
        case authenActions.AUTH_INITMENU_SUCCESS:
            return {
                ...state,
                MenuArray: payload.MenuArray || [],
            }
        case authenActions.AUTH_INITMENU_ERROR:
            return {
                ...state,
                MenuArray: [],
            }
        case authenActions.AUTTH_GET_PERMISSION_START:
            return {
                ...state,
            }
        case authenActions.AUTTH_GET_PERMISSION_INIT:
            return {
                ...state,
                PRMSMode: payload.PRMSMode
            }
        default:
            return {
                ...state,
                loadingInit: false
            };
    }
}